/* global SideDrawer, theme */

(function () {
  function initCartDrawer() {
    // Avoid double-registering
    if (window.customElements.get("cart-drawer")) return;

    if (typeof SideDrawer === "undefined") return false;

    class CartDrawer extends SideDrawer {
      connectedCallback() {
        // Bind once so "this" is always correct
        this.cartRefreshHandler = this.cartRefreshHandler.bind(this);
        this.bindEvents();
      }

      bindEvents() {
        this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
        this.closeDrawerViaEventHandler = this.close.bind(this, null);

        document.addEventListener("dispatch:cart-drawer:open", this.openDrawerViaEventHandler);
        document.addEventListener("dispatch:cart-drawer:close", this.closeDrawerViaEventHandler);
        document.addEventListener("dispatch:cart-drawer:refresh", this.cartRefreshHandler);

        this.addEventListener("on:cart-drawer:before-open", () => {
          if (window.theme && typeof theme.manuallyLoadImages === "function") {
            theme.manuallyLoadImages(this);
          }
          this.querySelectorAll("cc-cart-cross-sell").forEach((el) => el.init());
        });

        this.addEventListener("on:cart:after-merge", () => {
          if (window.theme && typeof theme.manuallyLoadImages === "function") {
            theme.manuallyLoadImages(this);
          }
          this.querySelectorAll("cc-cart-cross-sell").forEach((el) => el.init());
        });
      }

      disconnectedCallback() {
        document.removeEventListener("dispatch:cart-drawer:refresh", this.cartRefreshHandler);
        document.removeEventListener("dispatch:cart-drawer:open", this.openDrawerViaEventHandler);
        document.removeEventListener("dispatch:cart-drawer:close", this.closeDrawerViaEventHandler);
      }

      handleDrawerOpenViaEvent(evt) {
        this.open(evt && evt.detail ? evt.detail.opener : null);
      }

      cartRefreshHandler() {
        const form = this.querySelector("cart-form");
        if (form && typeof form.refresh === "function") form.refresh();
      }

      updateFromCartChange(html) {
        const form = this.querySelector("cart-form");
        if (form && typeof form.refreshFromHtml === "function") form.refreshFromHtml(html);
      }
    }

    window.customElements.define("cart-drawer", CartDrawer);
    return true;
  }

  // Try immediately
  if (initCartDrawer()) return;

  // Retry until vendor/main has loaded and SideDrawer exists
  let tries = 0;
  const maxTries = 200; // ~10 seconds at 50ms
  const timer = setInterval(() => {
    tries += 1;
    if (initCartDrawer() || tries >= maxTries) clearInterval(timer);
  }, 50);

  // Also try after typical load points
  window.addEventListener("load", () => initCartDrawer(), { once: true });
  ["click", "touchstart", "keydown", "mousemove", "scroll"].forEach((evt) => {
    window.addEventListener(evt, () => initCartDrawer(), { once: true, passive: true });
  });
})();
